// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_p6-0";